interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function PlusIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M8.75 2.25C8.75 1.83437 8.41563 1.5 8 1.5C7.58437 1.5 7.25 1.83437 7.25 2.25V7.25H2.25C1.83437 7.25 1.5 7.58437 1.5 8C1.5 8.41563 1.83437 8.75 2.25 8.75H7.25V13.75C7.25 14.1656 7.58437 14.5 8 14.5C8.41563 14.5 8.75 14.1656 8.75 13.75V8.75H13.75C14.1656 8.75 14.5 8.41563 14.5 8C14.5 7.58437 14.1656 7.25 13.75 7.25H8.75V2.25Z" />
    </svg>
  );
}
